interface Props {
  isExternal: boolean;
  openInNewTab: boolean;
}

export function getLinkRel({ isExternal, openInNewTab }: Props): string | undefined {
  const tokens: string[] = [];
  if (openInNewTab) {
    tokens.push('noopener');
  }

  if (isExternal) {
    tokens.push('noreferrer');
  }

  return tokens.join(' ') || undefined;
}
